import FeedbackThankYouModule from './FeedbackThankYouModule'

export default FeedbackThankYouModule
